import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const WorkTypeProfileFormContainer = styled.div`
  ${css`
    width: 100%;
  `}
`;
